import settingsComponent from './settings.component'

let settingsModule = angular.module('settings', [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider
      .state('settings', {
        url: '/settings',
        component: 'settings',
        data: {
          requireLogin: true
        },
        parent: 'app',
        children: ['users', 'branch', 'batch', 'itemType', 'items', 'location', 'carrier', 'truck', 'holiday', 'routes', 'log',
                   'branch_funding_source', 'reset_atm_code', 'service-settings', 'branch_funding_source_holiday',
                   'delivery_region_routing', 'service_ticket_parts', 'preventative-maintenance'
        ],
        resolve: {
          acl: (User) => {
            return User.getACL('setting')
          }
        }
      })
      .state('users', {
        url: '/users',
        component: 'users',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('branch', {
        url: '/branch',
        component: 'branch',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      // .state('customer', {
      //   url: '/customer',
      //   component: 'customer',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      // .state('contract', {
      //   url: '/contract',
      //   component: 'contract',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      .state('items-type', {
        url: '/items-type',
        component: 'itemType',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('items', {
        url: '/items',
        component: 'items',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('routes', {
        url: '/routes',
        component: 'routes',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('location', {
        url: '/location',
        component: 'location',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      // .state('message', {
      //   url: '/message',
      //   component: 'message',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({}),
      //     testing2: () => 'dsadas'
      //   }
      // })
      .state('carrier', {
        url: '/carrier',
        component: 'carrier',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      // .state('shiptype', {
      //   url: '/shiptype',
      //   component: 'shiptype',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      .state('truck', {
        url: '/truck',
        component: 'truck',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      }).state('vault', {
        url: '/vault',
        component: 'vault',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      }).state('batch', {
        url: '/batch',
        component: 'batch',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('holiday', {
        url: '/holiday',
        component: 'holiday',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      // .state('setup', {
      //   url: '/setup',
      //   component: 'setup',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      // .state('denomination', {
      //   url: '/denomination',
      //   component: 'denomination',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      .state('branch-funding-source', {
        url: '/branch-funding-source',
        component: 'branchFundingSource',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('log', {
        url: '/log',
        component: 'log',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('tntBilling', {
        url: '/tnt-billing',
        component: 'tntBilling',
        data: {
          requireLogin: true,
          requireACL: 'tnt_billing.view'
        },
        parent: 'app',
        children: [
          'tnt_billing_billable_events',
          'tnt_billing_billing_category',
          'tnt_billing_contract',
          'tnt_billing_customer',
          'tnt_billing_location_distance',
          'tnt_billing_fuel_surcharges'
        ],
        resolve: {
          acl: (User) => {
            return User.getACL('tntBilling')
          }
        }
      })
      .state('tntControl', {
        url: '/tnt-control',
        component: 'tntControl',
        data: {
          requireLogin: true,
          requireACL: 'tnt_control.view'
        },
        parent: 'app',
        children: [
          // 'tnt_control_configuration',
          'tnt_control_branch_setup',
          'tnt_control_shiptype',
          'tnt_control_denomination',
          'tnt_control_currency',
          'tnt_control_message',
          'tnt_control_mobile_app',
        ],
        resolve: {
          acl: (User) => {
            return User.getACL('tntControl')
          }
        }
      })
      .state('reporting', {
        url: '/reporting',
        component: 'reporting',
        data: {
          requireLogin: true,
          requireACL: 'reporting.view'
        },
        parent: 'app',
        children: [
          'reporting_liability',
          'reporting_route_performance'
        ],
        resolve: {
          acl: (User) => {
            return User.getACL('_reporting')
          }
        }
      })
      .state('branchManagement', {
        url: '/branch-management',
        component: 'branchManagement',
        data: {
          requireLogin: true,
          requireACL: 'branch_mgmt.view'
        },
        parent: 'app',
        children: [
          'branch_mgmt_routes','branch_mgmt_locations','branch_mgmt_items','branch_mgmt_tankers','branch_mgmt_bagouts',
          'branch_mgmt_orders','branch_mgmt_item_holds','branch_mgmt_location_holds','branch_mgmt_bypass_code',
          'branch_mgmt_daily_balance_sheet','branch_mgmt_monthly_report','branch_mgmt_deleted_shipments',
          'branch_mgmt_cancelled_shipments','branch_mgmt_branch_performance','branch_mgmt_final_residual_count_commit',
          'branch_mgmt_cash_transactions','branch_mgmt_tnt_bypass_code','branch_mgmt_physical_cash_count',
          'branch_mgmt_lock_open_errors','branch_mgmt_billing_approval','branch_mgmt_count_variances',        ],
      })
      // .state('mobile-app', {
      //   url: '/mobile-app',
      //   component: 'mobileApp',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      // .state('accounts', {
      //   url: '/accounts',
      //   component: 'accounts',
      //   parent: 'settings',
      //   // resolve: {
      //   //   hasACL: () => ({})
      //   // }
      // })
      .state('reset-atm-code', {
        url: '/reset-atm-code',
        component: 'resetAtmCode',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('soft-deleted-shipments', {
        url: '/soft-deleted-shipments',
        component: 'softDeletedShipments',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('service-settings', {
        url: '/service-settings',
        component: 'serviceSettings',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      // .state('billable-events', {
      //   url: '/billable-events',
      //   component: 'billableEvents',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      // .state('billing-category', {
      //   url: '/billing-category',
      //   component: 'billingCategory',
      //   parent: 'settings',
      //   resolve: {
      //     hasACL: () => ({})
      //   }
      // })
      .state('branch-funding-source-holiday', {
        url: '/branch-funding-source-holiday',
        component: 'branchFundingSourceHoliday',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('delivery-region-routing', {
        url: '/delivery-region-routing',
        component: 'deliveryRegionRouting',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('service-ticket-parts', {
        url: '/service-ticket-parts',
        component: 'serviceTicketParts',
        parent: 'settings',
        resolve: {
          hasACL: () => ({})
        }
      })
      .state('preventative-maintenance', {
        url: '/v2/index.html#/preventative-maintenance',
        component: 'preventativeMaintenance',
        resolve: {
          hasACL: () => ({})
        }
      })
  })
  .component('settings', settingsComponent)

  .name;

export default settingsModule;


// WEBPACK FOOTER //
// ./client/app/components/settings/index.js